import { ref } from '@vue/composition-api'
import { STORE_MODULE_NAME } from "./fencingStoreModule";

export default function useFencing() {

    // Table Handlers
  const tableColumns = ref([
      { key: 'fencing',
        label: 'ограждение',
      },
      { key: 'platform',
        label: 'платформа',
      },
      { key: 'user',
        label: 'пользователь',
      },
  ])

  const setupData = {
      formModel: {
          number: '',
          object_type:'',
          platform: '',
      },
  }

  const addDataUrl = `${STORE_MODULE_NAME}/create`
  const fetchDataUrl = `${STORE_MODULE_NAME}/fetch`

  return {

    addDataUrl,
    fetchDataUrl,

    tableColumns,
    setupData,
  }
}
